// import { firebaseAdapter } from "./providers/firebase.adapter";

import { supabaseAdapter } from './supabase.adapter';
import { setAuthAdapter } from '@/core/auth/authAdapter';

setAuthAdapter(supabaseAdapter);
export const adapter = supabaseAdapter;
